import React from 'react'
import Checked from '../../../../../assets/Checked.png'
import Unchecked from '../../../../../assets/Unfilled Check Mark.svg'
import './Icons.scss'

export const CheckedIcon = () => (
  <div className="check-icon">
    <img
      alt="Checked"
      className="check-svg"
      src={Checked}
    />
  </div>
)

export const UncheckedIcon = () => (
  <div className="check-icon">
    <img
      alt="Unchecked"
      className="check-svg"
      src={Unchecked}
    />
  </div>
)
